/* ------------------------------------------------------------------
   BBV — Menu età mobile (drawer Symmetry)  ·  v3 — 02/09/2026
   Sostituisce integralmente assets/bbv-age-menus.js

   v2 (già in live): reset dello stato del tema, altrimenti il menù
       restava invisibile (.mobile-navigation-drawer--child-open).
   v3: il "torna indietro" diventa GERARCHICO.
       - se è aperto un sotto-menu del tema (es. Abbigliamento)
         -> chiude solo quello e resta nella fascia (es. Bambino 2-8)
       - se sei alla radice della fascia
         -> torna alla selezione delle fasce
       La label si aggiorna da sola ("Torna a Bambino 2-8" /
       "Torna alla selezione"), anche se l'utente usa la freccia
       nativa del tema in alto.
------------------------------------------------------------------ */

(function () {
  var LABEL_ROOT = 'Torna alla selezione';

  function isChildOpen(drawer) {
    return drawer.classList.contains('mobile-navigation-drawer--child-open');
  }

  function activeFasciaLabel(drawer) {
    var handle = drawer.getAttribute('data-bbv-age');
    if (!handle) return '';
    var pill = drawer.querySelector('.bbv-age-pill[data-age-menu="' + handle + '"]');
    return pill ? pill.textContent.trim() : '';
  }

  function updateBackLabel(drawer) {
    var link = drawer.querySelector('.bbv-age-back');
    if (!link) return;
    var fascia = activeFasciaLabel(drawer);
    var text = (isChildOpen(drawer) && fascia) ? ('Torna a ' + fascia) : LABEL_ROOT;
    var span = link.querySelector('span');
    if (span) span.textContent = text;
    link.setAttribute('aria-label', text);
  }

  /* Chiude il tier-2 aperto dal tema (e le fisarmoniche tier-3 dentro),
     replicando quello che fa l'handler nativo .mobile-nav-back. */
  function closeChildTier(drawer) {
    drawer.classList.remove('mobile-navigation-drawer--child-open');

    drawer.querySelectorAll('.navigation__item--open').forEach(function (el) {
      el.classList.remove('navigation__item--open');
    });

    var title = drawer.querySelector('.mobile-nav-title');
    if (title) title.textContent = '';

    drawer.querySelectorAll('.navigation__tier-2-container').forEach(function (el) {
      el.style.top = '';
    });
    drawer.querySelectorAll('.navigation__child-tier').forEach(function (el) {
      el.style.height = '';
    });

    try {
      drawer.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (ex) {
      drawer.scrollTop = 0;
    }
  }

  /* Tiene la label allineata anche quando lo stato lo cambia il tema
     (freccia nativa in alto, apertura voce con figli). */
  function ensureObserver(drawer) {
    if (drawer.getAttribute('data-bbv-observed') === '1') return;
    drawer.setAttribute('data-bbv-observed', '1');
    new MutationObserver(function () {
      updateBackLabel(drawer);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.bbv-age-pill');
    var back = e.target.closest('.bbv-age-back');
    if (!pill && !back) return;

    var drawer =
      e.target.closest('.mobile-navigation-drawer') ||
      document.querySelector('.mobile-navigation-drawer');
    if (!drawer) return;

    ensureObserver(drawer);

    var gate = drawer.querySelector('.bbv-age-gate');
    var menusWrap = drawer.querySelector('.bbv-age-menus');
    var allMenus = drawer.querySelectorAll('.bbv-age-menu');

    // IL tier-1 "standard": figlio diretto del container, non i menu fascia
    var standardTier1 =
      drawer.querySelector('.navigation__tier-1-container > ul.navigation__tier-1') ||
      drawer.querySelector('.navigation__tier-1-container > ul');

    function openFascia(handle) {
      closeChildTier(drawer);
      drawer.setAttribute('data-bbv-age', handle);

      if (gate) gate.hidden = true;
      if (menusWrap) menusWrap.hidden = false;
      if (standardTier1) standardTier1.hidden = true;

      allMenus.forEach(function (m) { m.hidden = true; });
      var target = drawer.querySelector('.bbv-age-menu[data-age-menu="' + handle + '"]');
      if (target) target.hidden = false;

      updateBackLabel(drawer);
    }

    function backToGate() {
      closeChildTier(drawer);
      drawer.removeAttribute('data-bbv-age');

      allMenus.forEach(function (m) { m.hidden = true; });
      if (menusWrap) menusWrap.hidden = true;
      if (gate) gate.hidden = false;
      if (standardTier1) standardTier1.hidden = false;

      updateBackLabel(drawer);
    }

    if (pill) {
      e.preventDefault();
      openFascia(pill.getAttribute('data-age-menu'));
      return;
    }

    if (back) {
      e.preventDefault();
      if (isChildOpen(drawer)) {
        // 1° tap: esci dal sotto-menu, resta nella fascia
        closeChildTier(drawer);
        updateBackLabel(drawer);
      } else {
        // 2° tap: esci dalla fascia, torna alle pill
        backToGate();
      }
    }
  });
})();
